import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Button, Alert } from '@mui/material';
import HeaderPublic from '../../components/HeaderPublic';
import Footer from '../../components/Footer';
import { api } from '../../services/apiService';

const PublicSignup = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [designation, setDesignation] = useState('');
  const [organization, setOrganization] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!email.includes('@')) {
      setError('Please enter a valid email address');
      return;
    }
    try {
      setSubmitting(true);
      const payload = {
        firstName,
        lastName,
        email,
        phone,
        designation,
        company: organization,
        source: 'public',
      };
      const response = await api.post('/users/register', payload);
      if (response?.data) {
        setSuccess('Signup successful! Please check your email for next steps.');
        setFirstName('');
        setLastName('');
        setEmail('');
        setPhone('');
        setDesignation('');
        setOrganization('');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to sign up. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box sx={{ bgcolor: '#fff', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <HeaderPublic />

      <Container maxWidth="md" sx={{ flex: 1, py: 6 }}>
        <Box sx={{ mb: 3, textAlign: 'center' }}>
          <Typography variant="h4" sx={{ fontWeight: 700, color: '#0a1128', mb: 1 }}>Create your account</Typography>
          <Typography variant="body1" sx={{ color: '#666' }}>Fill in your details to get started.</Typography>
        </Box>

        <Box sx={{
          bgcolor: '#fff',
          border: '1px solid #e0e0e0',
          borderRadius: 2,
          boxShadow: 1,
          p: 3,
        }}>
          <form onSubmit={handleSubmit}>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <Box sx={{ flex: 1 }}>
                <label htmlFor="firstName" style={{ fontWeight: 600 }}>First Name</label>
                <input id="firstName" name="firstName" type="text" value={firstName} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}} onChange={(e) => setFirstName(e.target.value)} />
              </Box>
              <Box sx={{ flex: 1 }}>
                <label htmlFor="lastName" style={{ fontWeight: 600 }}>Last Name</label>
                <input id="lastName" name="lastName" type="text" value={lastName} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}} onChange={(e) => setLastName(e.target.value)} />
              </Box>
            </Box>

            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <Box sx={{ flex: 1 }}>
                <label htmlFor="email" style={{ fontWeight: 600 }}>Email</label>
                <input id="email" name="email" type="email" value={email} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}} onChange={(e) => setEmail(e.target.value)} />
              </Box>
              <Box sx={{ flex: 1 }}>
                <label htmlFor="phone" style={{ fontWeight: 600 }}>Phone</label>
                <input id="phone" name="phone" type="text" value={phone} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}} onChange={(e) => setPhone(e.target.value)} />
              </Box>
            </Box>

            <Box sx={{ mb: 2 }}>
              <label htmlFor="designation" style={{ fontWeight: 600 }}>Designation</label>
              <input id="designation" name="designation" type="text" value={designation} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}} onChange={(e) => setDesignation(e.target.value)} />
            </Box>

            <Box sx={{ mb: 2 }}>
              <label htmlFor="organization" style={{ fontWeight: 600 }}>Organization</label>
              <input id="organization" name="organization" type="text" value={organization} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}} onChange={(e) => setOrganization(e.target.value)} />
            </Box>

            {error && (<Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>)}
            {success && (<Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>)}

            <Button type="submit" disabled={submitting} sx={{ mt: 1, bgcolor: '#1BE885', color: '#212121', fontWeight: 700, border: 0, borderRadius: 1, px: 3, py: 1.2, '&:hover': { bgcolor: '#17d077' } }}>
              {submitting ? 'Submitting...' : 'Sign up'}
            </Button>
          </form>
        </Box>
      </Container>

      <Footer />
    </Box>
  );
};

export default PublicSignup;

